import _typeof from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/typeof.js";
import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useStoreState } from "pullstate";
import { get } from "lodash";
import Store from "../../../../utils/Store";
import { useCopilotAction, useCopilotAdditionalInstructions } from "@copilotkit/react-core";
import AddBulkTagging from "../../AddBulkTagging";
import { useAuth } from "@qure/qure-auth";
var useAddBulkTaggingWithAI = function useAddBulkTaggingWithAI(_ref) {
  var _getCustomTagParamete;
  var isDisabled = _ref.isDisabled,
    availableCustomFields = _ref.availableCustomFields,
    setFieldSelections = _ref.setFieldSelections,
    fieldSelections = _ref.fieldSelections,
    onSelectAssignee = _ref.onSelectAssignee,
    handleBulkTaggingUpdate = _ref.handleBulkTaggingUpdate,
    handleAssign = _ref.handleAssign;
  var getCustomTagParameters = function getCustomTagParameters(customFields) {
    var parameters = customFields === null || customFields === void 0 ? void 0 : customFields.map(function (tag) {
      var baseParam = {
        name: tag.tag,
        description: tag.description || "No description provided",
        required: false
      };
      if (tag.tag_type === "multi_dropdown") {
        var _tag$properties;
        return _objectSpread(_objectSpread({}, baseParam), {}, {
          type: "string[]",
          "enum": tag === null || tag === void 0 || (_tag$properties = tag.properties) === null || _tag$properties === void 0 ? void 0 : _tag$properties.options
        });
      } else if (tag.tag_type === "user") {
        var _tag$properties2;
        return _objectSpread(_objectSpread({}, baseParam), {}, {
          type: "string",
          "enum": tag === null || tag === void 0 || (_tag$properties2 = tag.properties) === null || _tag$properties2 === void 0 ? void 0 : _tag$properties2.options
        });
      } else if (tag.tag_type === "boolean") {
        return _objectSpread(_objectSpread({}, baseParam), {}, {
          type: "boolean"
        });
      } else if (tag.tag_type === "integer") {
        return _objectSpread(_objectSpread({}, baseParam), {}, {
          type: "number"
        });
      } else {
        return _objectSpread(_objectSpread({}, baseParam), {}, {
          type: "string"
        });
      }
    });
    return parameters;
  };
  useCopilotAdditionalInstructions({
    instructions: "\n        You are a helpful assistant that can add bulk tagging to the selected patients.\n      When user ask you to add bulk tagging, you will need to add the custom fields to the patients.\n      You will need to use the following parameters:\n      ".concat((_getCustomTagParamete = getCustomTagParameters(availableCustomFields)) === null || _getCustomTagParamete === void 0 ? void 0 : _getCustomTagParamete.map(function (param) {
      return "- ".concat(param.name);
    }).join("\n"), "\n      "),
    available: isDisabled ? "disabled" : "enabled"
  });
  var parseCustomFieldValues = function parseCustomFieldValues(field, value) {
    var _field$properties;
    if (field.tag_type === "date") {
      if (Array.isArray(value)) {
        var values = value.map(function (option) {
          return new Date(option).toISOString();
        });
        return values.filter(function (v) {
          return v !== undefined;
        });
      }
      return new Date(value).toISOString();
    } else if ((_field$properties = field.properties) !== null && _field$properties !== void 0 && _field$properties.options) {
      var _field$properties3;
      if (Array.isArray(value)) {
        var _values = value.map(function (option) {
          var _field$properties2;
          return field === null || field === void 0 || (_field$properties2 = field.properties) === null || _field$properties2 === void 0 || (_field$properties2 = _field$properties2.options) === null || _field$properties2 === void 0 ? void 0 : _field$properties2.find(function (o) {
            return o.trim().toLowerCase() === option.trim().toLowerCase();
          });
        });
        return _values.filter(function (v) {
          return v !== undefined;
        });
      }
      var formattedValue = field === null || field === void 0 || (_field$properties3 = field.properties) === null || _field$properties3 === void 0 || (_field$properties3 = _field$properties3.options) === null || _field$properties3 === void 0 ? void 0 : _field$properties3.find(function (option) {
        return option.trim().toLowerCase() === value.trim().toLowerCase();
      });
      return formattedValue ? formattedValue : "";
    }
    return value;
  };
  var saveAllTags = function saveAllTags(selectedTags, assignee) {
    if (assignee) {
      handleAssign();
    }
    handleBulkTaggingUpdate();
  };
  useCopilotAction({
    name: "addBulkTagging",
    description: "Add bulk tagging to the selected patients",
    parameters: getCustomTagParameters(availableCustomFields),
    available: isDisabled ? "disabled" : "enabled",
    handler: function () {
      var _handler = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(props) {
        var assignee, _fieldSelections, _loop, _ret, _i, _Object$entries, assistantIdentifier;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              assignee = null;
              _fieldSelections = [];
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var _availableCustomField;
                var _Object$entries$_i, key, value, tagId, field, parsedValue, fieldSelection;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
                      if (!(!key || typeof key !== "string")) {
                        _context.n = 1;
                        break;
                      }
                      console.warn("Invalid tag key:", key);
                      return _context.a(2, 0);
                    case 1:
                      if (!(value === undefined || value === null)) {
                        _context.n = 2;
                        break;
                      }
                      console.warn("Invalid tag value for key:", key);
                      return _context.a(2, 0);
                    case 2:
                      tagId = (_availableCustomField = availableCustomFields.find(function (tag) {
                        return tag.tag.toLowerCase() === key.toLowerCase();
                      })) === null || _availableCustomField === void 0 ? void 0 : _availableCustomField.id;
                      if (tagId) {
                        _context.n = 3;
                        break;
                      }
                      console.warn("Tag not found:", key);
                      return _context.a(2, 0);
                    case 3:
                      field = availableCustomFields.find(function (tag) {
                        return tag.tag.toLowerCase() === key.toLowerCase();
                      });
                      if (field) {
                        _context.n = 4;
                        break;
                      }
                      console.warn("Field not found:", key);
                      return _context.a(2, 0);
                    case 4:
                      parsedValue = parseCustomFieldValues(field, value);
                      if (key === "Assignee") {
                        onSelectAssignee(parsedValue);
                        assignee = parsedValue;
                      } else {
                        fieldSelection = {
                          field: field,
                          value: parsedValue,
                          isEditing: false,
                          editedValue: undefined
                        };
                        _fieldSelections.push(fieldSelection);
                      }
                    case 5:
                      return _context.a(2);
                  }
                }, _loop);
              });
              _i = 0, _Object$entries = Object.entries(props);
            case 1:
              if (!(_i < _Object$entries.length)) {
                _context2.n = 4;
                break;
              }
              return _context2.d(_regeneratorValues(_loop()), 2);
            case 2:
              _ret = _context2.v;
              if (!(_ret === 0)) {
                _context2.n = 3;
                break;
              }
              return _context2.a(3, 3);
            case 3:
              _i++;
              _context2.n = 1;
              break;
            case 4:
              setFieldSelections(function (prev) {
                return [].concat(_toConsumableArray(prev), _fieldSelections);
              });
              assistantIdentifier = Math.random().toString(36).substring(2, 10);
              Store.update(function (s) {
                s.lastAssitantMessageId = assistantIdentifier;
              });
              return _context2.a(2, {
                assignee: assignee,
                fieldSelections: _fieldSelections,
                assistantIdentifier: assistantIdentifier
              });
          }
        }, _callee);
      }));
      function handler(_x) {
        return _handler.apply(this, arguments);
      }
      return handler;
    }(),
    followUp: false,
    render: function render(_ref2) {
      var status = _ref2.status,
        result = _ref2.result;
      if (status === "complete") {
        return /*#__PURE__*/React.createElement(AddBulkTagging, {
          result: result,
          customFields: availableCustomFields,
          saveAllTags: saveAllTags,
          setFieldSelections: setFieldSelections,
          onSelectAssignee: onSelectAssignee
        });
      }
    }
  });
};
var useAddBulkTagging = function useAddBulkTagging(availableCustomFields, setFieldSelections, fieldSelections, onSelectAssignee, handleBulkTaggingUpdate, handleAssign) {
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        areFrontendToolsEnabled: s.areFrontendToolsEnabled
      };
    }),
    areFrontendToolsEnabled = _useStoreState.areFrontendToolsEnabled;
  var isAIAssistantEnabled = get(userInfo, ["settings", "ui_settings", "ai_assistant"], false);
  var isDisabled = !isAIAssistantEnabled || !userInfo || !areFrontendToolsEnabled;
  return useAddBulkTaggingWithAI({
    isDisabled: isDisabled,
    availableCustomFields: availableCustomFields,
    setFieldSelections: setFieldSelections,
    fieldSelections: fieldSelections,
    onSelectAssignee: onSelectAssignee,
    handleBulkTaggingUpdate: handleBulkTaggingUpdate,
    handleAssign: handleAssign
  });
};
var useIsBulkTaggingEnabled = function useIsBulkTaggingEnabled(selectedPatients) {
  var _useStoreState2 = useStoreState(Store, function (s) {
      return {
        areFrontendToolsEnabled: s.areFrontendToolsEnabled
      };
    }),
    areFrontendToolsEnabled = _useStoreState2.areFrontendToolsEnabled;
  var _useAuth2 = useAuth(),
    userInfo = _useAuth2.userInfo;
  var isAIAssistantEnabled = get(userInfo, ["settings", "ui_settings", "ai_assistant"], false);
  var isDisabled = !isAIAssistantEnabled || !userInfo || !areFrontendToolsEnabled;
  useCopilotAdditionalInstructions({
    instructions: "\n        If user ask you to add bulk tagging, ask user to select the patients first.\n        ",
    available: selectedPatients.size > 0 || isDisabled ? "disabled" : "enabled"
  });
  return isDisabled;
};
export { useAddBulkTagging, useIsBulkTaggingEnabled };